module.exports = __webpack_public_path__ + "static/media/id.f5aa8121.svg";